import { KiteCheckbox, KiteTextInput } from '@kite/react-kite';
import React, { useState } from 'react';
import { QuizCardInputs } from './QuizCardsInput';
export const QuizCard3 = (props: QuizCardInputs) => {
    const me = props.config[props.idx];

    const [zip, setZip] = useState(``);

    const onChecked = (evt) => {
        const isChecked = evt.target.checked;
        me.value.multipleLocations = isChecked;
        me.valid = isChecked || !!me.value.zipcode;
        props.setConfig([...props.config]);
    };

    const onChange = (evt) => {
        const re = /^[0-9\b]+$/;
        const value = evt.target.value.replace(/\D/g, ``);
        if (evt.target.value === `` || re.test(evt.target.value)) {
            me.value.zipcode = evt.target.value;
        }
        if (evt.target.value.length === 5) {
            me.valid = !!me.value.multipleLocations || !!me.value.zipcode;
        } else {
            me.valid = false;
            if (me.value.multipleLocations) {
                me.valid = true;
            }
        }
        props.setConfig([...props.config]);
        setZip(value);
    };

    return (
        <>
            <KiteTextInput
                name="zipcode"
                aria-label="zipcode"
                onChange={onChange}
                maxLength={5}
                value={zip}
                disabled={!props.viewable}
            />
            <KiteCheckbox
                checked={!!me.value[`multipleLocations`]}
                label="I have multiple locations"
                id="multiple"
                name="multiple"
                value="yes"
                onChange={onChecked}
                disabled={!props.viewable}
            />
        </>
    );
};
